import React from 'react';
import block from 'bem-cn';
import flagIMG from './img/flag.png';

import './InputSimplePhone.scss';

const b = block('input-simple-phone');

const InputSimplePhone = ({
  value,
  name,
  placeholder = '',
  size = 'default',
  isRequired,
  onChange,
  validState = 1,
  color,
  isMobile=false,
  countryCode='+54',
  flag = flagIMG,
  phoneLimit = 11,
  ...props
}) => {

  const handleFieldChange = e => {
    if (/^\d*$/.test(e.currentTarget?.value) && e.currentTarget?.value?.length <= phoneLimit) {
      onChange(e);
    }
  }

  return (
    <div className={b({ size, color })}>
      <img className={b('flag')} src={flag} alt="" />
      <div className={b('country')}>{countryCode}</div>
      <div className={b('separator')} />
      <input
          name={name}
          value={value}
          placeholder={placeholder || ''}
          onChange={handleFieldChange}
          className={b('field')}
          required={isRequired}
          {...props}
        />
    </div>
  )
};

export default InputSimplePhone;
